module.exports = __webpack_public_path__ + "img/notebook.1515aeec.svg";